import { css, useTheme, type Theme } from '@emotion/react';
import { darken } from 'polished';
import { BookBookmark, X } from '@phosphor-icons/react';
import { ListItemFigure } from 'client/components/Other/ListItemFigure';
import { Typography } from 'client/components/Typography';

export const QuickLaunchWarning = () => {
  const theme = useTheme();

  return (
    <div css={contentStyle}>
      <ListItemFigure
        size={64}
        icon={<BookBookmark color={theme.color.grey[100]} />}
        ornament={<X weight="bold" size={32} color={theme.color.grey[100]} />}
      />

      <Typography variant="h6">No Repository Configured</Typography>
      <Typography variant="body2">
        This project was created with Quick Launch and is not connected to a GitHub repository. If you wish to use a repository, you have to
        create a new project.
      </Typography>
    </div>
  );
};

const contentStyle = (theme: Theme) => {
  const bgSvgColor = darken(0.03, theme.color.grey[60]).replace('#', '%23');

  return css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    background-color: ${theme.color.grey[60]};
    border-radius: ${theme.borderRadius}px;

    background-size: 100%;
    background-repeat: no-repeat;
    background-position: -90px -40px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='192' height='192' viewBox='0 0 256 256'%3E%3Cpath fill='none' d='M0 0h256v256H0z'/%3E%3Ccircle cx='128' cy='128' r='96' fill='none' stroke='${bgSvgColor}' stroke-linecap='round' stroke-linejoin='round' stroke-width='16'/%3E%3Cpath d='M141.4 132.6a28 28 0 1 0-26.8 0l-13.8 32.2a8 8 0 0 0 7.3 11.2h39.8a8 8 0 0 0 7.3-11.2Z' fill='none' stroke='${bgSvgColor}' stroke-linecap='round' stroke-linejoin='round' stroke-width='16'/%3E%3C/svg%3E");

    > figure {
      margin-top: 1.5rem;
      margin-bottom: 1rem;
    }

    > p {
      max-width: 50ch;
      text-align: center;
    }
  `;
};
